<template>
    <div v-if="service.id">
        <span class="coupon-label">
            {{ $t('coupon.price') }}
        </span>
        <span>{{ formattedPrice }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'coupon-pricing',
    props: {
        service: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            currency: 'getCurrency',
            upperLocale: 'upperLocale',
            localeString: 'getLocaleString',
        }),

        formattedPrice() {
            if (this.service.enablePricing) {
                const localisedDescription = this.service[`priceDescription${this.upperLocale}`];
                if (this.service.price) {
                    const localisedPrice = this.service.price.toFixed(2) + '$';

                    if (localisedDescription) {
                        return localisedPrice + ', ' + localisedDescription;
                    }

                    return localisedPrice;
                }

                if (localisedDescription) {
                    return localisedDescription;
                }

                return this.$i18n.t('appt.feesWillApply');
            }

            return this.$i18n.t('appt.freeOfCharges');
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
